import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FILTER_HEALTH_TIER_LEVELS } from 'dpl/constants/query_params';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import SmartLink from 'dpl/components/SmartLink';
import { HEALTH_TESTING_GUIDE_PATH } from 'dpl/shared/constants/urls';
import { healthTiersResourceDefinition } from 'dpl/breeder_search_results/utils/queryDefinitions';
import Banner from 'dpl/common/design_system/Banner';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';

export default function BreederBreedHealthFilter({
  title,
  subtitle,
  resultsType
}) {
  const { breedName } = useSelector(({ server }) => server);

  const {
    value: { data: healthTiers }
  } = useResourceQuery(healthTiersResourceDefinition(true));

  const healthTierOptions = useMemo(
    () =>
      healthTiers?.map(tier => {
        return { title: `${tier.title} level testing`, value: tier.id };
      }),
    [healthTiers]
  );

  return (
    <>
      <MultiSelectChecklistFilter
        filterTitle={title}
        filterSubtitle={subtitle}
        filterParam={FILTER_HEALTH_TIER_LEVELS}
        filterOptions={healthTierOptions}
      />
      <Banner
        color="gray"
        iconName="fetch-info-24"
        type="horizontal"
        className="font-16 items-center"
      >
        {resultsType === RESULTS_TYPES.PUPPIES ? (
          <>
            All Good Dog breeders agree to meet health testing requirements for
            their breed. Levels are awarded when documentation is provided for
            each parent dog.
          </>
        ) : (
          <>
            <SmartLink
              className="stone-700 underline"
              to={HEALTH_TESTING_GUIDE_PATH}
              target="_blank"
            >
              Learn more
            </SmartLink>{' '}
            about health testing for {breedName}.
          </>
        )}
      </Banner>
    </>
  );
}

BreederBreedHealthFilter.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  resultsType: PropTypes.string
};

BreederBreedHealthFilter.defaultProps = {
  title: null,
  subtitle: null,
  resultsType: null
};
